var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar-for-beta"}},[_c('KeyboardShortcutsOverlay'),_c('TheNavigationBar'),_c('PortalManager'),_c('EvolveMessageCenter'),_c('StatusPageWidget')],1)}
var staticRenderFns = []

export { render, staticRenderFns }